export enum HeadingTextPositionType {
  Center = "CENTER",
  Left = "LEFT",
}
